import { bindEvents } from '../../assets/js/helpers';

import ImageController from '../../assets/js/controller/image';


const selector = 'collage';

export default class Collage {

	constructor(section) {
		this.el = {
			section,
			slideshow: section.querySelector(`.${selector}__slideshow`),
			images: section.querySelectorAll(`.${selector}__slideshow-images li`),
			captions: section.querySelectorAll(`.${selector}__slideshow-captions li`),
			current: section.querySelector('.index-controls__current'),
			previous: section.querySelector('.index-controls [data-control-previous]'),
			next: section.querySelector('.index-controls [data-control-next]')
		};

		this.active = 0;

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	static get selector() {
		return selector;
	}

	showSlide(index) {
		if (index < 0) index = this.el.images.length - 1;
		if (index > this.el.images.length - 1) index = 0;
		for (let i = 0, l = this.el.images.length; i < l; ++i) {
			if (i === index) {
				const img = this.el.images[i].querySelector('img');
				if (!img.dataset.touched) {
					img.dataset.touched = true;
					ImageController.swap(img);
				}
				this.el.images[i].classList.add('is-active');
				this.el.captions[i].classList.add('is-active');
			} else {
				this.el.images[i].classList.remove('is-active');
				this.el.captions[i].classList.remove('is-active');
			}
		}
		this.active = index;
		const current = index + 1;
		this.el.current.innerText = current < 10 ? `0${current}` : current;
	}

	_onSlideshowReveal() {
		this.showSlide(0);
	}

	_onPreviousClick(e) {
		e.preventDefault();
		this.showSlide(this.active - 1);
	}

	_onNextClick(e) {
		e.preventDefault();
		this.showSlide(this.active + 1);
	}

	addEventListeners() {
		this.el.slideshow.addEventListener('reveal', this.events._onSlideshowReveal);

		this.el.previous.addEventListener('click', this.events._onPreviousClick);
		this.el.next.addEventListener('click', this.events._onNextClick);
	}

	removeEventListeners() {
		this.el.slideshow.removeEventListener('reveal', this.events._onSlideshowReveal);

		this.el.previous.removeEventListener('click', this.events._onPreviousClick);
		this.el.next.removeEventListener('click', this.events._onNextClick);
	}

	destroy() {
		this.removeEventListeners();
	}

}
